import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const searchTlc = "/api/business/decision-volatility";
const searchTlcV2 = "/api/business/v2/decision-volatility";
const searchCompany = "/api/business/companyList";
const searchCompanyV2 = "/api/business/v2/companyList";
const exportExcel = "/api/business/decision-volatility/excel";
export default class FeeCodeListCpnService {
	private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

	public getSearchReceipt(querySearch: any, cancelToken): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.post(searchTlc, querySearch, { cancelToken: cancelToken.token })
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	public getSearchReceiptV2(querySearch: any, cancelToken): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.post(searchTlcV2, querySearch, { cancelToken: cancelToken.token })
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	public getAllCompany(params?: any): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get(searchCompany, {
					params: params,
				})
				.then((resp) => {
					resolve(resp.data);
				})
				.catch(() => {});
		});
	}

	public getAllCompanyV2(params?: any): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get(searchCompanyV2, {
					params: params,
				})
				.then((resp) => {
					resolve(resp.data);
				})
				.catch(() => {});
		});
	}

	public ExportExcel(params: any, data?: any): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.post(exportExcel + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params), data, { responseType: "blob" })
				.then((resp) => {
					resolve(resp);
				})
				.catch(() => {});
		});
	}
}
